import {Component, Input} from '@angular/core';
import {NgClass} from '@angular/common';
import {SvgDirective, svgSize} from '../svg.directive';

@Component({
  selector: 'app-info-circle',
  templateUrl: './info-circle.component.html',
  styleUrls: ['./info-circle.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    SvgDirective
  ]
})
export class InfoCircleComponent {
  @Input()
  size?: svgSize;
}
